import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dreamy%20abstract%20fashion%20collage%20with%20soft%20pastel%20garments%20floating%20ethereally%20against%20warm%20blush%20and%20cream%20gradient%20background%20delicate%20fabric%20draped%20organically%20with%20subtle%20sparkle%20particles%20and%20golden%20light%20rays%20editorial%20fantasy%20aesthetic&width=1800&height=1200&seq=hero-bg-main-v2&orientation=landscape"
          alt="Superbuy Spreadsheet curated fashion products collection"
          title="Superbuy Spreadsheet - Verified Products Collection"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/50 via-background-50/30 to-background-50/80"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 pt-24 pb-16 text-center">
        <p className="text-sm md:text-base font-label tracking-widest uppercase text-foreground-500 mb-6">
          Trusted by 10,000+ Smart Buyers Worldwide
        </p>
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-extrabold text-foreground-950 leading-tight mb-6">
          Superbuy<br />
          <span className="text-primary-500">Spreadsheet</span>
        </h1>
        <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto mb-10 leading-relaxed">
          Discover the most trusted Superbuy Spreadsheet featuring verified products, quality control guides,
          shipping tutorials, and curated buying resources for smarter shopping.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer group"
          >
            Start Shopping
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200"></i>
          </a>
          <Link
            to="/article/superbuy-spreadsheet-complete-guide"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border border-foreground-200 text-foreground-700 text-base font-medium hover:bg-background-100 hover:border-foreground-300 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Read the Guide
            <i className="ri-book-open-line"></i>
          </Link>
        </div>
      </div>

      <div className="absolute bottom-[-20px] left-1/2 -translate-x-1/2 w-full max-w-5xl px-4 md:px-6 z-10 hidden md:flex justify-center gap-4">
        <a
          href="https://kaspreadsheet.com/category-911-Shoes.html"
          target="_blank"
          rel="noopener nofollow"
          className="relative w-[220px] h-[260px] rounded-2xl overflow-hidden bg-background-50 border border-background-200/50 hover:border-background-300/60 transition-all duration-400 hover:-translate-y-2 cursor-pointer z-10 mt-4"
        >
          <img
            src="https://readdy.ai/api/search-image?query=Luxurious%20cream%20leather%20sneakers%20with%20golden%20accents%20photographed%20from%20above%20on%20soft%20moss%20green%20velvet%20fabric%20with%20tiny%20wildflowers%20delicate%20morning%20dew%20droplets%20editorial%20product%20photography%20dreamy%20atmosphere&width=440&height=520&seq=hero-card-shoes-v2&orientation=portrait"
            alt="Superbuy Spreadsheet Shoes category"
            title="Shoes - Superbuy Spreadsheet"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-50/95 to-transparent pt-12 pb-4 px-4">
            <span className="text-sm font-semibold text-foreground-900">Shoes</span>
          </div>
        </a>
        <a
          href="https://kaspreadsheet.com/search-912/name/Shoes.html"
          target="_blank"
          rel="noopener nofollow"
          className="relative w-[220px] h-[260px] rounded-2xl overflow-hidden bg-background-50 border border-background-200/50 hover:border-background-300/60 transition-all duration-400 hover:-translate-y-2 cursor-pointer z-20 mt-0"
        >
          <img
            src="https://readdy.ai/api/search-image?query=Charcoal%20grey%20brushed%20fleece%20hoodie%20draped%20artfully%20on%20weathered%20wooden%20stool%20with%20warm%20fairy%20lights%20twinkling%20in%20background%20autumn%20evening%20mood%20cozy%20editorial%20fashion%20photography%20cinematic%20atmosphere&width=440&height=520&seq=hero-card-hoodies-v2&orientation=portrait"
            alt="Superbuy Spreadsheet Hoodies category"
            title="Hoodies - Superbuy Spreadsheet"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-50/95 to-transparent pt-12 pb-4 px-4">
            <span className="text-sm font-semibold text-foreground-900">Hoodies</span>
          </div>
        </a>
        <a
          href="https://kaspreadsheet.com/search-913/name/Shoes.html"
          target="_blank"
          rel="noopener nofollow"
          className="relative w-[220px] h-[260px] rounded-2xl overflow-hidden bg-background-50 border border-background-200/50 hover:border-background-300/60 transition-all duration-400 hover:-translate-y-2 cursor-pointer z-10 mt-4"
        >
          <img
            src="https://readdy.ai/api/search-image?query=Soft%20butter%20yellow%20cotton%20tee%20with%20subtle%20stripes%20folded%20neatly%20on%20white%20linen%20with%20fresh%20daisies%20and%20vintage%20sunglasses%20bright%20cheerful%20summer%20morning%20light%20editorial%20lifestyle%20photography&width=440&height=520&seq=hero-card-tshirts-v2&orientation=portrait"
            alt="Superbuy Spreadsheet T-Shirts category"
            title="T-Shirts - Superbuy Spreadsheet"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-50/95 to-transparent pt-12 pb-4 px-4">
            <span className="text-sm font-semibold text-foreground-900">T-Shirts</span>
          </div>
        </a>
      </div>
    </section>
  );
}